import React from 'react';
import { Bar } from 'react-chartjs-2';

const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
        {
            label: 'Incentive',
            data: [45, 89, 55, 87, 96, 25, 50, 78, 45, 100, 85, 70],
            backgroundColor: ["#06825B", "#F19D2D"],
        }
    ],
};

const options = {
    height: "600",

    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                },
            },
        ],
    },
};
export default function IncentivechartPage() {
    return (
        <div>
            <h5 className="d-flex align-items-center justify-content-between">Incentive
                <div className="chartfilter">
                    <select className="form-control ">
                        <option>Monthly</option>
                        <option>Weekly</option>
                        <option>Daily</option>
                    </select>
                </div>
            </h5>
            <Bar data={data} height={240} options={options} />
        </div>
    )
}
